import script from "./DetailExplain.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailExplain.vue?vue&type=script&setup=true&lang=js"

import "./DetailExplain.vue?vue&type=style&index=0&id=b27b7aac&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b27b7aac"]])

export default __exports__